import Lista from './Lista';
import UploadLista from './UploadLista';

export const FechamentoDeFolhaLista = Lista;
export const FechamentoDeFolhaUploadLista = UploadLista;
